import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { HubsSelectionComponent } from './hubs-selection.component';
import { HubsSelectionDialogComponent } from './hubs-dialog/hubs-selection-dialog.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { ActionButtonComponent, ListFilterComponent, SvgIconComponent } from '../../ui-kit';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxsModule } from '@ngxs/store';
import { HubListState } from '../../store/state/administration/hub';
import { DirectivesModule } from '../../common/directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    ListFilterComponent,
    MatCheckboxModule,
    ActionButtonComponent,
    MatDialogModule,
    RouterModule,
    NgxsModule.forFeature([HubListState]),
    TranslateModule.forChild({}),
    DirectivesModule,
    SvgIconComponent,
  ],
  exports: [HubsSelectionComponent, HubsSelectionDialogComponent],
  declarations: [HubsSelectionComponent, HubsSelectionDialogComponent],
})
export class HubsSelectionModule {}
